export default "/images/7ac111dace813abbfee04805ccc32bd7.avif";